import {createApp} from 'vue';
import App from './App.vue';

import drag from "v-drag"
// eslint-disable-next-line no-unused-vars
import { saveAs } from 'file-saver'; 

const app = createApp(App);
app.use(drag);
app.mount('#app');


